// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oFCO","selected":"styles_selected__2j62R"};